import $ from 'jquery';

import certcaptureLoader from 'chairisher/thirdparty/certcapture';
import ModalFactory from 'chairisher/factory/modal';

import { getEcommerceTokenUrl, getTaxFreeStateNames, getTaxFreeText } from 'chairisher/context/tax';

/**
 * Creates tax exemption modal
 *
 * @param {string} shipZone The ship/exposure zones
 * @param {Object} accountAddress
 * @param {string} accountAddress.name
 * @param {string} accountAddress.street_address
 * @param {string} accountAddress.city
 * @param {string} accountAddress.state_name
 * @param {string} accountAddress.country_name
 * @param {string} accountAddress.postal_code
 */
export function showTaxExemptionModal(shipZone, accountAddress) {
    if (getTaxFreeStateNames().indexOf(shipZone) !== -1) {
        const $pluginModal = ModalFactory.createModal('tax-free-modal');
        $pluginModal.appendTo(document.body);
        $pluginModal.find('.js-modal-body').text(getTaxFreeText());
        $pluginModal.modal('show');
    } else {
        $.ajax({
            dataType: 'json',
            method: 'POST',
            url: getEcommerceTokenUrl(),
        }).done(({ token, guid }) => {
            const $pluginModal = ModalFactory.createModal('js-certcapture-plugin');
            $pluginModal.appendTo(document.body);
            // show an empty modal first, so users aren't left waiting with no feedback while we wait for the
            // Certcapture plugin to load.  The plugin does provide a spinny animation while it initializes, and that
            // animation starts quickly, so users will have more feedback than just an empty modal.
            $pluginModal.modal('show');
            certcaptureLoader((ecommercePlugin) => {
                ecommercePlugin.init($pluginModal.find('.js-modal-body')[0], {
                    ship_zone: shipZone, // required field
                    token, // required field
                    edit_purchaser: true,
                    fill_only: true,
                    primary_color: '#2E5167', // @blue
                    secondary_color: '#CC4639', // @red
                    onCertSuccess() {
                        $pluginModal.modal('hide');
                        window.location.reload(true);
                    },
                });

                ecommercePlugin.setCustomerNumber(guid);

                ecommercePlugin.setCustomerData({
                    name: accountAddress.name,
                    address1: accountAddress.street_address,
                    city: accountAddress.city,
                    state: accountAddress.state_name,
                    country: accountAddress.country_name,
                    zip: accountAddress.postal_code,
                });

                ecommercePlugin.show();
            });
        });
    }
}

export const canShowTaxExemptionModal = !!getEcommerceTokenUrl();
